/**
 *
 * Asynchronously loads the component for Yourplan
 *
 */

import { lazyLoad } from 'utils/loadable';

export const Yourplan = lazyLoad(
  () => import('./index'),
  module => module.Yourplan,
);
